import { render, staticRenderFns } from "./MaterialBidTile.vue?vue&type=template&id=50a40c39&scoped=true&lang=pug&"
import script from "./MaterialBidTile.vue?vue&type=script&lang=js&"
export * from "./MaterialBidTile.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBidTile.vue?vue&type=style&index=0&id=50a40c39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a40c39",
  null
  
)

export default component.exports